import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";

// @ts-prune-ignore-next
export interface IProgressBarProps {
  // The progress of the bar, from 0 to 100
  progress: number;
}

export const SelfServeProgressBar: React.FC<IProgressBarProps> = ({
  progress,
}) => {
  const { strictLocalize } = useStrictLocalization();
  return (
    <ProgressBarWrapper>
      <Bar
        $progress={Math.min(progress, 100)}
        color={Core.surface.default}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
        aria-valuetext={strictLocalize(
          {
            defaultMessage: "{progressNumber} percent of progress completed",
            description: {
              text: "Alt text for completion of a progress bar",
              img: "https://cdn.faire.com/fastly/cc1042723d7167f76c3bae278733852f3ee364ff08812d6596fada79072564fb.png",
            },
          },
          { progressNumber: progress }
        )}
        role="progressbar"
      />
    </ProgressBarWrapper>
  );
};

const ProgressBarWrapper = styled(Row).attrs({ align: "center" })`
  height: ${getSpacing("2x")};
  width: 100%;
`;

const Bar = styled.div<{ $progress: number }>`
  position: relative;
  background-color: ${Core.border.muted};
  height: 6px;
  flex: 1;
  &::before {
    content: "";
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    height: 100%;
    width: ${({ $progress }) => $progress}%;
    background-color: ${Core.surface.default};
    transition: width 0.4s cubic-bezier(0.7, -0.4, 0.4, 1.4);
  }
`;
